import { createRoot } from "react-dom/client";
import { NewCaseFormShadowbox } from "../../new_case_shadowbox/NewCaseShadowbox";

export const initNewCaseShadowbox = () => {
  const newCaseFormContainer = document.getElementById("new_case_shadowbox");

  if (newCaseFormContainer) {
    const root = createRoot(newCaseFormContainer);
    const { updateUrl, createUrl, draftId, draftData, isDraftPersisted, clinicProvidersUrl, uninsuredPatientPayor } =
      newCaseFormContainer.dataset;

    const parsedDraftId = draftId ? JSON.parse(draftId) : null;
    const parsedDraftData = draftData ? JSON.parse(draftData) : null;

    root.render(
      <NewCaseFormShadowbox
        draftId={parsedDraftId}
        draftData={parsedDraftData}
        hasDraft={isDraftPersisted === "true"}
        updateUrl={updateUrl}
        createUrl={createUrl}
        clinicProvidersUrl={clinicProvidersUrl}
        uninsuredPatientPayor={JSON.parse(uninsuredPatientPayor)}
      />
    );
  }
};
